import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from './sub_components/toast';
import * as authServices from '../services/authService'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import * as authUtil from "../util/auth.util";
let oid = OPERATOR_ID.toLowerCase()
class SetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      oldpasscode: "",
      repasscode: "",
      date: "",
      passVisible: false,
      oldpassVisible: false,
      repassVisible: false,
      showToast: false,
      toastMsg: "",
      toastType: ""
    };
  }
  formatPickerDate(date) {
    var d = date,
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    year = year.toString().slice(-2)
    return [year, month, day].join('');
  }
  componentDidMount() {
    let userData = localStorage.getItem("tokenData")
    userData = JSON.parse(userData)
    if (!userData.sub) {
      // let appType = localStorage.getItem("appType")
      //   let rememberData = localStorage.getItem("rememberData")
      //   localStorage.clear()
      //   localStorage.setItem("rememberData",rememberData)
      //   if(appType === "mobile"){
      //       window.location.href = window.location.origin+"/apk";
      //   }else{
      //       window.location.href = window.location.origin+"/auth";
      //   }
      authUtil.logout();
    } else {
      this.setState({ uid: userData.sub })
    }
    let date = this.formatPickerDate(new Date())
    this.setState({ date: date })
  }
  handleKey(e) {
    if (e.keyCode === 13) {
      if (this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode) {
        this.submitForm();
      } else {
        this.props.notify("Invalid", "error")
      }
    }
  }
  async submitForm() {
    if (!this.state.oldpasscode) {
      this.props.notify("Enter Verification Cod", "error")
      return false
    }
    if (!this.state.passcode) {
      this.props.notify("Please insert new password!", "error")
      return false
    }
    if (this.state.passcode.length < 6) {
      this.props.notify("Password must have atlist 6 digit!", "error")
      return false
    }
    if (this.state.passcode !== "" && this.state.passcode !== this.state.repasscode) {
      this.props.notify("Confirm password does not match!", "error");
      return false
    }
    if (
      this.state.oldpasscode === this.state.passcode
    ) {
      this.props.notify("New password Cannot be same as Old password!", "error");
      return false;
    }
    let body = {
      "OldPassword": this.state.oldpasscode,
      "NewPassword": this.state.passcode,
      "ConfirmPassword": this.state.repasscode
    }
    await authServices.setPassword(body).then((res) => {
      if (res.isSuccess) {
        let appType = localStorage.getItem("appType")
        if (appType === "mobile") {
          this.props.history.push("/apk");
        } else {
          this.props.history.push("/auth");
        }
      } else {
        this.props.notify(res.exception.message, "error")
      }
    })
  }
  showToast(msg, type) {
    let self = this
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
      setTimeout(() => {
        self.setState({ toastMsg: "", toastType: "", showToast: false })
      }, 3000);
    })
  }
  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      if (name === "passcode" && !!value) {
        if (value.match(/[0-9]/g)) {
          document.getElementById("digit").className = "success-text"
        } else {
          document.getElementById("digit").className = ""
        }
        if (value.match(/[a-zA-Z]/g)) {
          document.getElementById("scharacter").className = "success-text"
        } else {
          document.getElementById("scharacter").className = ""
        }
        if (value.length >= 8) {
          document.getElementById("minlength").className = "success-text"
        } else {
          document.getElementById("minlength").className = ""
        }
        if (value === this.state.oldpasscode) {
          document.getElementById("notold").className = "error-text d-block"
        } else {
          document.getElementById("notold").className = "error-text d-none"
        }
        if (value.toLowerCase().indexOf(this.state.uid.toLowerCase()) !== -1) {
          document.getElementById("notuser").className = "error-text d-block"
        } else {
          document.getElementById("notuser").className = "error-text d-none"
        }
      }
    })
  }

  onPasswodVisible(passid, name, value) {
    if (!!value) {
      document.getElementById(passid).type = "Password"
    } else {
      document.getElementById(passid).type = "text"
    }
    this.setState({ [name]: !value })
  }

  render() {
    return (<body className="bethubs login_back radheexchlogin loginbg">
      <div className="login_front">
        <div className="login_card">
          <div className="rllogin-header">
            <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" />
          </div>
          <div className="login_wrapper">
            <div className="form-group">
              <div className="col-md-12">
                <input className="form-control pass_input" tabIndex={2} type="password" value={this.state.oldpasscode} name="oldpasscode" id="oldpasscode" onChange={(e) => { this.onChange(e) }} onKeyUp={(e) => { this.handleKey(e) }} placeholder="Enter Old Password" />
                <span onClick={() => { this.onPasswodVisible("oldpasscode", "oldpassVisible", this.state.oldpassVisible) }} className="setPasscode-visible">{!!this.state.oldpassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
              </div>
            </div>
            <div className="form-group">
              <div className="col-md-12 change-password-valid">
                <input className="form-control pass_input" tabIndex={2} type="password" value={this.state.passcode} name="passcode" id="passcode" onChange={(e) => { this.onChange(e) }} onKeyUp={(e) => { this.handleKey(e) }} placeholder="Enter New password" />
                <span onClick={() => { this.onPasswodVisible("passcode", "passVisible", this.state.passVisible) }} className="setPasscode-visible">{!!this.state.passVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                {!!this.state.passcode && <>
                  <ul>
                    <li id="digit" className="success-text"><i className="fa fa-check"></i> At least 1 digit</li>
                    <li id="scharacter" className=""><i className="fa fa-check"></i> At least 1 character</li>
                    <li id="minlength" className=""><i className="fa fa-check"></i> Minimum 8 characters</li>
                  </ul>
                  <ul>
                    <li id="notold" className="error-text d-none"><i className="fa fa-close"></i> Password not same as old</li>
                    <li id="notuser" className="error-text d-none"><i className="fa fa-close"></i> Password Not contain Username</li>
                  </ul>
                </>}
              </div>
            </div>
            <div className="form-group">
              <div className="col-md-12">
                <input className="form-control pass_input" tabIndex={2} type="password" value={this.state.repasscode} name="repasscode" id="repasscode" onKeyUp={(e) => { this.handleKey(e) }} onChange={(e) => { this.onChange(e) }} placeholder="Re-Enter password" />
                <span onClick={() => { this.onPasswodVisible("repasscode", "repassVisible", this.state.repassVisible) }} className="setPasscode-visible">{!!this.state.repassVisible ? <i className="fa fa-eye" aria-hidden="true"></i> : <i className="fa fa-eye-slash" aria-hidden="true"></i>}</span>
                {this.state.passcode !== "" && this.state.passcode !== this.state.repasscode && <span className="error">This field should be same as password.</span>}
              </div>
            </div>
          </div>
          <div className="login_ftrmy">
            {/* <button type="submit" className="btn btn-primary" tabIndex={3} onClick={(e) => { this.submitForm() }} disabled={this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode !== this.state.oldpasscode && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 && this.state.passcode === this.state.repasscode ? false : true}>Login</button> */}
            <button type="submit" className="btn btn-primary" tabIndex={3} onClick={(e) => { this.submitForm() }} disabled={this.state.passcode.match(/[0-9]/g) && this.state.passcode.match(/[a-zA-Z]/g) && this.state.passcode.length >= 8 && this.state.passcode.toLowerCase().indexOf(this.state.uid.toLowerCase()) === -1 ? false : true}>Login</button>
            <div className="log-footer">
            </div>
          </div>
        </div>
      </div>
      {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
    </body>)
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SetPassword);